import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import LanguageSelector from '../../LanguageSelector';

function AccountMenuActions({ t }) {
	return (
		<Box px={2} paddingTop={2} paddingBottom={2}>
			<Box>
				<LanguageSelector
					placeholder={t('language_selector:select_your_lang')}
					withBorder
				/>
			</Box>
		</Box>
	);
}

AccountMenuActions.propTypes = {
	t: PropTypes.func.isRequired,
};

export default AccountMenuActions;
